import ApiResponsePaginationHeaders from "utils/ApiResponsePaginationHeaders"

// This function assumes an API function defined in app/javascript/services/api.js
// as an argument. It is expected that the response from the API will include
// pagination headers.  This utility function will work if the API response
// does not include the headers, but it will only make one request for the resource.
//
// In addition to the API response including pagination headers, it is assumed that
// the API response will be an array.
//
// An optional onPageLoad() callback function can be passed.  The onPageLoad() function
// will be called after each page is fetched from the API.  The function will be passed
// the ApiResponsePaginationHeaders instance created from the request's headers
// and the count of resources in the response.
const paginatedResourceList = ({ apiFunction, onPageLoad }) => async (...args) => {
  let page = 1
  let paginationHeaders = {}
  let resourceList = []

  while (page === 1 || (paginationHeaders.page && page <= paginationHeaders.totalPages)) {
    /* eslint-disable-next-line no-await-in-loop */
    const response = await apiFunction(...args, page)

    if (!response.ok) {
      throw new Error("Fetching paginated resource failed")
    }

    resourceList = resourceList.concat(response.data)
    paginationHeaders = new ApiResponsePaginationHeaders(response)
    onPageLoad?.({ paginationHeaders, pageResourceCount: response.data.length })
    page += 1
  }

  return resourceList
}

export default paginatedResourceList
